var TextInputAlignment;
(function (TextInputAlignment) {
    TextInputAlignment["CHARACTERS"] = "characters";
    TextInputAlignment["NONE"] = "none";
    TextInputAlignment["SENTENCES"] = "sentences";
    TextInputAlignment["WORDS"] = "words";
})(TextInputAlignment || (TextInputAlignment = {}));
export default TextInputAlignment;
//# sourceMappingURL=text-input-capitalize.js.map